import type { Insulin as ApiInsulin } from "@tandemdiabetes/sugarmate-api-react-client"
import type { Insulin } from "src/types"

export function transformInsulin(insulin: ApiInsulin): Insulin {
  const {
    id,
    deleted,
    ...otherProps
  } = insulin

  return {
    ...otherProps,
    id: `${id}`,
    is_deleted: !!deleted,
  }
}
